export default __webpack_public_path__ + "static/media/35A32A_0_0-2edd6f4d3bf442eec48dfea33fb98ade.3dac852c.woff2";